import styled from 'styled-components';
import ToggleButtonComponent from 'src/areas/product-collection/components/toggle-button';
import { media } from '@prisjakt/ui-base';

export const ToggleButton = styled(ToggleButtonComponent)`
  display: none;

  ${media.mediumDown`
    display: block;
  `}
`;
